import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import BlogSingle from '../../components/BlogDetails/BlogSingle.js';
import Footer from '../../components/footer/Footer';
import ErrorPage from '../ErrorPage/ErrorPage';
import { useBlog } from '../../config/BlogProvider';
import { useLanguage } from '../../context/LanguageContext';
import { findBySlug, getTranslation } from '../../utils/article';

const BlogDetails = () => {
    const { slug } = useParams();
    const { articles, loading } = useBlog();
    const { lang } = useLanguage();
    const { t } = useTranslation(['blog', 'common']);

    if (loading) {
        return (
            <Fragment>
                <Navbar />
                <PageTitle pageTitle={'...'} pagesub={t('blog:pageTitle')} />
                <div className="section-padding container"><p>{t('common:loading')}</p></div>
                <Footer ftClass={'s2'} />
                <Scrollbar />
            </Fragment>
        );
    }

    const article = findBySlug(articles, slug);
    if (!article) return <ErrorPage />;

    const picked = getTranslation(article, lang);
    const title = picked ? picked.tr.title : '';

    return (
        <Fragment>
            <Navbar />
            <PageTitle pageTitle={title} pagesub={t('blog:pageTitle')} />
            <BlogSingle article={article} />
            <Footer ftClass={'s2'} />
            <Scrollbar />
        </Fragment>
    );
};
export default BlogDetails;
